module.exports = __webpack_public_path__ + "static/media/fgn.6d6404f3.png";